// action types
export const REPORT_CONSENT_UPDATE_ERROR = "reportConsentUpdateError";
export const CONSUME_CONSENT_UPDATE_ERROR = "consumeConsentUpdateError";
export const CLEAR_CONSENT_UPDATE_ERROR = "clearConsentUpdateError";

// mutation types
export const SET_CONSENT_UPDATE_ERROR = "setConsentUpdateError";
export const REMOVE_CONSENT_UPDATE_ERROR = "removeConsentUpdateError";

function normalizeError(e) {
  const status = e?.response?.status;
  const data = e?.response?.data;
  return {
    message: data?.message || e?.message || "Sync with PRIVO failed.",
    status,
    details: data?.errors || null,
    ts: Date.now(),
    raw: e
  };
}

export default {
  state: {
    updateErrorsByPid: {} // { [participantId]: { message, status, details, ts, raw } }
  },

  getters: {
    /**
     * Return the consent update error for participantId (or null)
     */
    getConsentUpdateError(state) {
      return pid => state.updateErrorsByPid[pid] || null;
    }
  },

  actions: {
    [REPORT_CONSENT_UPDATE_ERROR](state, { participantId, error }) {
      state.commit(SET_CONSENT_UPDATE_ERROR, { participantId, error });
    },

    [CONSUME_CONSENT_UPDATE_ERROR](state, participantId) {
      const err = state.getters.getConsentUpdateError(participantId);
      if (err) state.commit(REMOVE_CONSENT_UPDATE_ERROR, participantId);
      return err || null;
    },

    [CLEAR_CONSENT_UPDATE_ERROR](state, participantId) {
      state.commit(REMOVE_CONSENT_UPDATE_ERROR, participantId);
    }
  },

  mutations: {
    [SET_CONSENT_UPDATE_ERROR](state, { participantId, error }) {
      state.updateErrorsByPid = {
        ...state.updateErrorsByPid,
        [participantId]: normalizeError(error)
      };
    },

    [REMOVE_CONSENT_UPDATE_ERROR](state, participantId) {
      const copy = { ...state.updateErrorsByPid };
      delete copy[participantId];
      state.updateErrorsByPid = copy;
    }
  }
};
